// extracted by mini-css-extract-plugin
module.exports = {"addQuickBooksDesktopWindow":"addQuickBooksDesktopWindow__p5LbN","dialog":"dialog__aPu4L","content":"content__hVflh","img":"img__-iR2g","text":"text__lUiad"};